import { type Dispatch, type SetStateAction, useContext } from 'react';
import { ActivePageContext } from '@trinity/chat-components/components/Chat/context';
import { SidePanelToggleContext } from '@trinity/chat-components/components/Chat.SidePanel/context';
import { SidePanelExpandedContext } from './context';

type Props = {
  children: React.ReactNode;
};

// Kept for SidePanelExpandedContext shape compatibility — panel expansion is fully
// driven by SidePanelToggleContext and ActivePageContext.
const noopSetExpanded: Dispatch<SetStateAction<boolean>> = () => {};

export const SidePanelContainer = (props: Props) => {
  const { layout } = useContext(ActivePageContext);
  const { isOpen } = useContext(SidePanelToggleContext);
  const isExpanded = layout === 'side_chat' || isOpen;

  return (
    <SidePanelExpandedContext.Provider value={[isExpanded, noopSetExpanded]}>
      {props.children}
    </SidePanelExpandedContext.Provider>
  );
};
